window.addEventListener("DOMContentLoaded", (event) => {
  const stickyATC = document.querySelector("#md-sticky-atc");
  const img = stickyATC.querySelector(".product-content img");
  const btn = stickyATC.querySelector('[name="add"]');
  const atcButton = document.getElementById("product-section");
  const selectField = stickyATC.querySelector('select[name="id"]');

  let observer = new IntersectionObserver(function (entries, observer) {
      if (!entries[0].isIntersecting) {
        stickyATC.classList.add("show");
        document.documentElement.style.paddingBottom = `${stickyATC.clientHeight}px`;
        document.documentElement.style.height = "auto";
      }
      else {
        stickyATC.classList.remove("show");
        document.documentElement.style.paddingBottom = "0";
      }
  });
  
  observer.observe(atcButton)

  if (selectField) {
    selectField.addEventListener("change", () => {
      img.setAttribute(
        "src",
        selectField.options[selectField.selectedIndex].dataset.img
      );
    });
  }

  document
    .querySelector('.product-form [name="id"]')
    ?.addEventListener("change", (e) => {
      const value = Number(e.target.value);
      if (value) {
        selectField.value = value;
      }
    });
});
